import Loading from "@/components/Loading";
import AdminLayout from "@/layout/AdminLayout";
import React from "react";
import {PAGE_URL} from "../services/constant";
const FeaturedContent = React.lazy(() =>
    import('../FeaturedContent')
);
const featuredContentRoutesRegistry = [
    {
        path: PAGE_URL.FEATURED_CONTENT_PAGE,
        element: <FeaturedContent />,
        loading: <Loading />,
        layout: AdminLayout,
    },
];

export default featuredContentRoutesRegistry;
